// import './common/rem'
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './routers/index'
import { mapActions } from 'vuex'

import('./assets/less/app.less')
import { trim, time2text, forIn, isNumber } from './utils/base'

import components from './components/index.js'
import {textNumber} from './utils/formatter'
import {dataFormat} from './utils/base'
// filters
forIn(
  {
    trim,
    time2text
  },
  (fn, key) => Vue.filter(key, fn)
)
// Vue.filter('trim', trim);
// Vue.filter('time2text', time2text);
Vue.filter('textNumber', textNumber)
Vue.filter('dataFormat', dataFormat)
Vue.use(components)

window.wzWebApp = new Vue({
  router,
  store,
  el: '#webApp',
  render: h => h(App),
  computed: {},
  methods: {
    ...mapActions('account', ['load']),
    ...mapActions('home', ['loadBase']),
    ...mapActions('timer', { timerStart: 'start' }),
  },
  async created() {
    this.timerStart({})

    // 路由跳转， 底导航条设置
    // const {
    //   $route
    // } = this
    // const afterEach = (to) => {
    //   // const {meta} = to
    //   // if(meta && isNumber(meta.tabIndex)) {
    //   //   this.setTab(meta.tabIndex)
    //   // }
    //   // this[SET_NAV](meta.tabIndex);
    //   // const appName = 'kline';
    //   // let className = document.body.className || ''
    //   // className = className.replace(/\s*\b(?:kline)\b/g, '') + ' ' + appName
    //   // className = trim(className)
    //   // document.body.className = className
    // }
    // this.$router.afterEach(afterEach)
    // if ($route.meta) {
    //   afterEach($route)
    // }

    
    // 加载用户信息
    await this.load()
    this.loadBase()
    
    // 统计代码
    // Stat.init({router: this.$router});
    
  },
  beforeDestroy() {
    // this.timerStop()
  }
})
